<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
   <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-calendar text-primary"></i> Attendance Reports</h5>
      </div>
      <hr />
      <div class="row g-3">
              <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu">
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        <div class="col-md-3">
          <label class="form-label">Section<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.sectionID" @change="listData">
            <option selected=""></option>
            <option v-for="(item, index) in secList" :key="index" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
  <label class="form-label">Month<sup><span class="text-danger font-12">*</span></sup>:</label>
  <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.month">
    <option disabled value="">Select Month</option>
    <option v-for="(item, index) in monthList" :key="index" :value="item">{{ item }}</option>
  </select>
</div>
        <div class="col-md-9 text-end mt-1">
          <button class="btn btn-sm btn-success me-1" @click="save()">
            <i class="fa fa-search text-white me-1"></i>Go
          </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
       <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>

      <div class="row" v-if="showtable">
        <div class="col-md-4 text-start mt-2">
        <span>Class: <strong  class='text-success me-2'> {{clsList.find(cls => cls._id ==
              Obj.clsID)?.name || ''}} ({{secList.find(sec => sec._id == Obj.sectionID)?.Name || ''
                }})</strong></span>
        </div>
         <div class="col-md-8 text-end mt-2 ms-md-0 ms-n3">
        <span>Present: <strong  class='text-success me-2'>P</strong></span>
        <span>Absent: <strong  class='text-danger me-2'>A</strong></span>
        <span>Holiday: <strong  class='text-info me-2'>H</strong></span>
         <i class="fas fa-print text-primary me-1" role="button" @click="printcontent"></i>
          <i class="fas fa-download me-md-4 me-0" role="button" @click="downloadModalContent"></i>
        </div>
        <div class="col-md-12 table-responsive mt-2">
            <div class="progress mb-0 progress-sm" v-if="progress != 0 ">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <input v-if="List.length > 0" v-model="search" type="search" placeholder="Search..." class="form-control form-control-sm mb-1 mt-1"/>
           <span v-if="isFutureMonth()" class="fw-bold fs-5">No Records...</span>
       <table v-if="List.length !== 0" class="table table-bordered custom-table" style="font-size:12px;">
            <thead>
              <tr class="bg-primary text-white">
                <th>R.No</th>
                <th>Name</th>
                <th v-for="day in daysInMonth" :key="day">{{ day }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredRows" :key="index">
            <td>{{ item.StudentId?.rollNo || '-' }}</td>
            <td>{{ item.StudentId?.firstName || '-' }} {{ item.StudentId?.lastName || ' ' }}</td>
           <td v-for="day in daysInMonth" 
    :key="day"
    :class="{
      'text-success': getAttendanceStatus(item.attendance, day, activeMonth, activeYear) === 'P',
      'text-danger': getAttendanceStatus(item.attendance, day, activeMonth, activeYear) === 'A',
      'text-info': getAttendanceStatus(item.attendance, day, activeMonth, activeYear) === 'H'
    }">
  {{ getAttendanceStatus(item.attendance, day, activeMonth, activeYear) }}
</td>
          </tr>
            </tbody>
          </table>
        </div>
      </div>
  <div ref="modalContent" class="invisible-content">
    <div class="card me-2 ms-23 mt-">
        <div class="d-flex justify-content-center align-items-center text-center">
            <img :src="getUrl(profile && profile.Image)" alt="School Logo" width="100" height="100" class="me-2 mb-3"/>
            <div class="me-5 mb-4">
              <h2 class="fw-bold mb-0">{{ profile && profile.Name }}</h2>
              <p class="mb-0 small fw-bold">{{ profile && profile.Address }}</p>
              <p class="mb-0 small  fw-bold">{{ profile && profile.Email }}</p>
              <p class="mb-0 small fw-bold">+91 {{ profile &&profile.MobileNo }}</p>
            </div>
          </div>
        <hr>
        <div class="col-md-12 text-center mt-2">
          <p class="text-bg-primary mb-1 border border-dark border-2 border-shadow">Student Attendance Register {{Obj.month}}</p>
        </div>
      <div class="row">
        <div class="d-flex">
         <div class="col-md-6 text-start mt-2 mr-2">
         <span>Class: <strong  class='text-success me-2'> {{clsList.find(cls => cls._id ==
              Obj.clsID)?.name || ''}} ({{secList.find(sec => sec._id == Obj.sectionID)?.Name || ''
                }})</strong></span>
        </div>
         <div class="col-md-6 text-end mt-2 mr-3">
        <span>Present: <strong  class='text-success me-2'>P</strong></span>
        <span>Absent: <strong  class='text-danger me-2'>A</strong></span>
        <span>Holiday: <strong  class='text-info me-2'>H</strong></span>
        </div>
        </div>
        <div class="col-md-12 table-responsive mt-2">
         <span v-if="List.length === 0" class="fw-bold fs-5">No Records...</span>
       <table v-if="List.length !== 0" class="table table-bordered custom-table">
  <thead>
    <tr class="bg-primary text-white">
      <th class="w-75">R.No</th>
      <th class="w-100">Name</th>
      <th v-for="day in daysInMonth" :key="day">{{ day }}</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(item, index) in List" :key="index">
  <td>{{ item.StudentId?.rollNo || '-' }}</td>
  <td>{{ item.StudentId?.firstName || '-' }} {{ item.StudentId?.lastName || ' ' }}</td>
<td v-for="day in daysInMonth" 
    :key="day"
    :class="{
      'text-success': getAttendanceStatus(item.attendance, day, activeMonth, activeYear) === 'P',
      'text-danger': getAttendanceStatus(item.attendance, day, activeMonth, activeYear) === 'A',
      'text-info': getAttendanceStatus(item.attendance, day, activeMonth, activeYear) === 'H'
    }">
  {{ getAttendanceStatus(item.attendance, day, activeMonth, activeYear) }}
</td>

</tr>
  </tbody>
</table>
        </div>
      </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import {  api } from '@/utils/helpers.js';
import { ref, onMounted, computed,} from 'vue'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList, profile } = schoolStore();
const search = ref('')
  const  Obj = ref( { clsID: "", sectionID: "", month: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const List= ref([])
    const List1= ref([])
    const   errors= ref({})
    const showtable=ref(false)
   const modalContent = ref(null);
   const isFutureMonth = () => {
  if (activeMonth.value === null || activeYear.value === null) return false;
  const today = new Date();
  const currentMonth = today.getMonth(); 
  const currentYear = today.getFullYear();
  return (
    activeYear.value > currentYear ||
    (activeYear.value === currentYear && activeMonth.value > currentMonth)
  );
};
const getAttendanceStatus = (attendanceArr, day, month, year) => {
  if (month == null || year == null) return "";
  const dateObj = new Date(year, month, day); 
  const isSunday = dateObj.getDay() === 0;
  if (isSunday) return 'H';

  // If attendanceArr exists, check record
  if (attendanceArr && attendanceArr.length > 0) {
    const Month = String(month + 1).padStart(2, '0');
    const Day = String(day).padStart(2, '0');
    const targetDateStr = `${year}-${Month}-${Day}`;

    const record = attendanceArr.find(a => {
      const attndDateStr = new Date(a.attndDate).toISOString().split('T')[0];
      return attndDateStr === targetDateStr;
    });

    if (record) {
      const isPresent = record.attendance?.some(sub => sub.status === true);
      return isPresent ? 'P' : 'A';
    }
  }
  const today = new Date();
  if (year < today.getFullYear() || (year === today.getFullYear() && month <= today.getMonth())) {
    return 'A';
  }
  return ''; 
};
const filteredRows = computed(() => {
  if (!search.value) return List.value;
  return List.value.filter(row => {
    const rollNo = String(row.StudentId?.rollNo || '').toLowerCase();
    const name = String(row.StudentId?.firstName || '').toLowerCase();
    const keyword = search.value.toLowerCase();
    return rollNo.includes(keyword) || name.includes(keyword);
  });
});

const listData= async()=> {
  await api .get(`/students/clssection/${Obj.value.clsID}/${Obj.value.sectionID}`)
  .then((res) => { List1.value = res.data });
}
const printcontent = async() => {
       const printContent = modalContent.value?.innerHTML;
       const printWindow = window.open('', '', 'width=900,height=700');
      printWindow.document.write(`
   <html>
     <head>
       <style>
       @page{size: Landscape;} body { font-family: Arial, sans-serif; padding: 20px; }
         .text-center { text-align: center; } .mb-0{margin-bottom:-10px;} .mb-2{margin-bottom:5px;}
         .mt-5{margin-top:-130px;} .mb-5{margin-bottom:20px;} .ms-2{margin-left:60px;} .mr-2{margin-right:230px;} 
         .mr-3{margin-left:315px;} h2{font-size:35px; margin-top:-10px;} .w-100{width:70px; padding:0px}
         .d-flex{display: flex; align-items: center;} .w-75{width:25px;}
         .border-1{border:1px solid #ccc; } .h-100{height:100px;}
         .border-shadow{ background-color:#3f87fd !important; color:black; border:2px solid black;}
         .text-success{margin-bottom:10px; margin-right:10px; color:green;} .text-danger{margin-bottom:10px; margin-right:10px;color:red;}
         table { border-collapse: collapse; width: 100%; table-layout: fixed; word-wrap: break-word; font-size:10px;}
         th, td { border: 1px solid #ccc; text-align: center; font-size: 10px; }
         img { max-width: 120px !important; height: 120px !important; margin-left:200px; margin-right:10px; }
         @media print { .border-shadow {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        background-color: #3f87fd !important;}
        thead tr{ -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        background-color: #3f87fd !important;}
       </style>
     </head>
     <body onload="window.print(); window.close();">
       ${printContent}
     </body>
   </html>
 `);
       printWindow.document.close();
     }
     const downloadModalContent = async() => {
      const modalElement = modalContent.value;
      if (!modalElement) return;
      try {
        const canvas = await html2canvas(modalElement, {
          scale: 4,
          useCORS: true,
        });
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation: 'Landscape',
          unit: 'px',
          format: [canvas.width, canvas.height],
        });
        pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
        pdf.save('Attendance-Report.pdf');
      } 
      catch (error) { console.error('Error generating PDF:', error); }
    }
const progress = ref(0)
let progressInterval = null; 
const save = async () => {
  if (progressInterval) {
    clearInterval(progressInterval);
    progressInterval = null;
  }
  progress.value = 0;
  let direction = 1;
  progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);
  const fields = {
    Class: { value: Obj.value.clsID, validators: [isRequired] },
    Section: { value: Obj.value.sectionID, validators: [isRequired] },
    Month: { value: Obj.value.month, validators: [isRequired] },
  };
  errors.value = validateForm(fields);

  if (Object.keys(errors.value).length > 0) {
    progress.value = 0;
    if (progressInterval) clearInterval(progressInterval);
    return;
  }
  updateActiveMonth();
  if (isFutureMonth()) {
    List.value = [];
    showtable.value = true;
    progress.value = 0;
    if (progressInterval) {
      clearInterval(progressInterval);
      progressInterval = null;
    }
    return;
  }
  await listData();
  const selectedMonthIndex = activeMonth.value;
  const selectedYearInt = activeYear.value;
  const apiUrl = `/reports/attendance/${Obj.value.clsID}/${Obj.value.sectionID}/${selectedMonthIndex + 1}/${selectedYearInt}`;
  try {
    const response = await api.get(apiUrl);
    const attendanceData = response.data;
    const filteredAttendance = Array.isArray(attendanceData)
      ? attendanceData.filter(a => {
          const attndDate = new Date(a.attndDate);
          return attndDate.getMonth() === selectedMonthIndex && attndDate.getFullYear() === selectedYearInt;
        })
      : [];
    if (filteredAttendance.length === 0) {
      const fullList = List1.value.map(student => {
        return {
          StudentId: student,
          attendance: [], 
        };
      });
      List.value = fullList;
      showtable.value = true;
    } else {
      const fullList = List1.value.map(student => {
        const studentAttendance = filteredAttendance.filter(a => a.studentID === student._id);
        return {
          StudentId: student,
          attendance: studentAttendance,
        };
      });
      List.value = fullList;
      showtable.value = true;
      msgObj.value = { msg: "Attendance fetched successfully.", role: "success", show: true };
    }
  } catch (error) {
    console.error(error);
    msgObj.value = { msg: "Failed to fetch attendance report.", role: "danger", show: true };
  } finally {
    progress.value = 0;
    if (progressInterval) {
      clearInterval(progressInterval);
      progressInterval = null;
    }
  }
};
 const getUrl = (img) => {
      if (!img) return process.env.VUE_APP_API_URL + "/images/Logo.png";
      let imgUrl = img.startsWith("..") ? img.substring(2) : img;
      
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
    }
    const reset= async() => {
      Obj.value = {clsID: "", sectionID: "", month: "", };
      errors.value = {};
      showtable.value=false;
    }
const monthList = computed(() => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); 
  const academicYearStart = currentMonth >= 5 ? currentYear : currentYear - 1;
  const list = [];
  for (let m = 5; m <= 11; m++) {
    list.push(`${monthNames[m]}-${academicYearStart}`);
  }
  for (let m = 0; m <= 3; m++) {
    list.push(`${monthNames[m]}-${academicYearStart + 1}`);
  }
  return list;
});
const currentMonthYear = () => {
  const now = new Date();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${monthNames[now.getMonth()]}-${now.getFullYear()}`;
};
const activeMonth = ref(null);
const activeYear = ref(null);
const daysInMonth = ref([]);
const updateActiveMonth = () => {
  const [monStr, yearStr] = Obj.value.month.split("-");
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul",
                      "Aug", "Sep", "Oct", "Nov", "Dec"];
  activeMonth.value = monthNames.indexOf(monStr);
  activeYear.value = parseInt(yearStr);

  const days = new Date(activeYear.value, activeMonth.value + 1, 0).getDate();
  daysInMonth.value = Array.from({ length: days }, (_, i) => i + 1);
};
onMounted(() => {
  const current = currentMonthYear();
  if (monthList.value.includes(current)) {
    Obj.value.month = current;
  } else {
    Obj.value.month = "";
  }
});
</script>
